import React, { FC, useEffect } from 'react';

import { DraggableWorksheetFormComponent, WorksheetFormElementOption } from '@packages/models/api';
import AddField from './add-field';
import { AddFieldType } from './worksheet-form-component-edit-modal';
import colors from '@packages/core/styles/colors';
import { useValidationField } from './hooks/useValidationField';

interface FormWorksheetEditImageGridProps extends DraggableWorksheetFormComponent {
    onChange({
        formElementLabel,
        options,
        formElementDescription,
    }: {
        formElementLabel?: string;
        options?: WorksheetFormElementOption[] | undefined;
        worksheetElementTooltip?: string;
        formElementDescription?: string;
    }): void;
    addField: AddFieldType;
    setIsValid: React.Dispatch<React.SetStateAction<boolean>>;
}

export const FormEditImageGrid: FC<FormWorksheetEditImageGridProps> = ({
    formElementLabel,
    formElementTooltip,
    formElementDescription,
    options,
    onChange,
    addField,
    setIsValid,
}) => {
    const {
        fieldHandlers: { handleRequired },
        fieldErrorMessages,
        isValid,
    } = useValidationField();

    useEffect(() => {
        setIsValid(isValid);
    }, [isValid, setIsValid]);

    return (
        <>
            <AddField
                addFieldValues={addField}
                onchangeText={onChange}
                formElementTooltip={formElementTooltip}
                formElementDescription={formElementDescription}
                formElementLabel={formElementLabel}
                errorMessage={fieldErrorMessages?.questionLabel}
                handleRequired={handleRequired}
            />

            <hr style={{ borderWidth: 2, borderColor: colors.grayTwo }} />
        </>
    );
};
